import {ChangeDetectionStrategy, Component, ElementRef, inject, input} from '@angular/core';
import {LotteryListItemComponent} from "../../../../components/lottery-list-item/lottery-list-item.component";
import {ApartmentWithApplicationInfo, ApplicationService} from "../../../../services/application.service";
import {EstimatedEligibilityPipe} from "../../../../pipes/estimated-eligibility.pipe";
import {SubmitButtonComponent} from "../../../../components/submit-button/submit-button.component";
import {NgClass} from "@angular/common";
import confetti from "canvas-confetti";
import {map, switchMap, tap, timer} from "rxjs";

@Component({
  selector: 'homey-open-lottery-list-item',
  imports: [
    LotteryListItemComponent,
    EstimatedEligibilityPipe,
    SubmitButtonComponent,
    NgClass
  ],
  templateUrl: './open-lottery-list-item.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class OpenLotteryListItemComponent {
  public readonly openInPopup = input(false);
  public readonly noNegativeMargin = input(false);
  public readonly lottery = input.required<ApartmentWithApplicationInfo>()
  private readonly applicationService = inject(ApplicationService);
  private readonly hostRef = inject(ElementRef<HTMLElement>);
  submit = () => timer(500).pipe(
    switchMap(() => this.applicationService.applyForApartment(this.lottery().id)),
    tap(didApply => {
      if (didApply) this.launchConfetti();
    }),
    map(() => {})
  );

  private launchConfetti() {
    const origin = this.getOrigin();
    confetti({
      particleCount: 40,
      spread: 90,
      startVelocity: 8,
      ticks: 220,
      origin,
      zIndex: 9999,
    });
  }

  private getOrigin() {
    if (typeof window === 'undefined') return {x: 0.5, y: 0.7};
    const applyButton = this.hostRef.nativeElement.querySelector('homey-submit-button button')
      ?? this.hostRef.nativeElement.querySelector('button.apply-button')
      ?? this.hostRef.nativeElement.querySelector('button:last-of-type')
      ?? this.hostRef.nativeElement;

    const rect = applyButton.getBoundingClientRect();
    const x = (rect.left + rect.width / 2) / window.innerWidth;
    const y = (rect.top + rect.height / 2) / window.innerHeight;
    const clamp = (v: number) => Math.min(0.98, Math.max(0.02, v));
    return {x: clamp(x), y: clamp(y)};
  }
}
